import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { AppDispatch, store } from '../redux/store';
import { ReduxController } from '../redux/utils/ReduxController';
import tpcQuestionApi from '../redux/api/questionApiSlice';

@customElement('tpc-corrector-question-view-report')
export class TPCQuestionViewReport extends LitElement {
    createRenderRoot() {
        return this;
    }
    dispatch = store.dispatch as AppDispatch;
    rxController = new ReduxController(this);
    get store() {
        return this.rxController.state;
    }
    @state()
    private active = false;

    @state()
    loading = false;

    @state()
    inputReport = '';

    @property({ type: String })
    questionUuid: string | undefined

    activateReport() {
        this.active = true;
        this.emitReportActive();
    }

    closeReport() {
        this.active = false;
        this.inputReport = '';
        this.emitReportActive();
    }

    emitReportActive() {
        this.dispatchEvent(
            new CustomEvent('reportActive', {
                detail: {
                    active: this.active,
                },
            })
        );
    }

    async sendReport() {
        if (this.loading || !this.inputReport.trim().length || !this.questionUuid) {
            return;
        }
        this.loading = true;
        await this.dispatch(
            tpcQuestionApi.endpoints.sendFeedback.initiate({
                feedback: this.inputReport,
                type: 'error',
                tpc_uuid: this.questionUuid,
                isTutor: this.store.appState.isTutor,
            })
        );
        this.loading = false;
        this.closeReport();
    }

    render() {
        return html`
            <div
                class="tpc-corrector-question-view-content-actions-report ${this.active
                    ? 'active'
                    : ''}"
            >
                <div class="tpc-corrector-question-view-content-actions-report-header">
                    <span @click=${this.activateReport}>
                        <span class="icon icon-075-error-flag"></span>
                        Reportar problema
                    </span>
                    <button class="close-button" @click=${this.closeReport}>
                        <span class="icon icon-027-outline-close"></span>
                    </button>
                </div>
                <div
                    class="tpc-corrector-question-view-content-actions-report-content-shadow"
                    @click=${this.closeReport}
                ></div>
                <div class="tpc-corrector-question-view-content-actions-report-content">
                    <div class="tpc-corrector-question-view-content-actions-report-content-title">
                        <span class="icon icon-075-error-flag"></span>
                        Reportar problema
                    </div>
                    <div
                        class="tpc-corrector-question-view-content-actions-report-content-textarea-container"
                    >
                        <textarea
                            class="tpc-corrector-question-view-content-actions-report-content-textarea"
                            placeholder="Explique o problema encontrado..."
                            @input=${(event: Event) =>
                                (this.inputReport = (event.target as HTMLTextAreaElement).value)}
                            .value=${this.inputReport}
                            maxlength="500"
                        ></textarea>
                        <button
                            class="ds-button ds-button--primary submit-button"
                            @click=${this.sendReport}
                            .disabled=${this.loading}
                        >
                            ${this.loading ? 'Enviando...' : 'Enviar'}
                        </button>
                    </div>
                </div>
            </div>
        `;
    }
}
